export const environment = {
  production: true,
  //uncomment if baseUrl is configuration for build
  //baseUrl: '/dsweb/',
  baseUrl: '/',
  apiUrl: 'api/v1',
  geo: '__GEOURL__',
  sso: '__SSOURL__',
  userdetail: 'https://graph.microsoft.com/',
  theming: {
    defaultLogoHyperlink: 'https://www.google.com'
  },
  snackbarDelayBeforeClose: 3000
};
